import { InMemoryPdfDownloadService } from "../pdf-download/index.js";
import type {
  PlatformGlobals,
  PlatformGlobalsFactory,
} from "./PlatformGlobals.js";

export class InMemoryPlatformGlobalsFactory implements PlatformGlobalsFactory {
  constructor(
    private readonly opts: {
      readonly origin?: string;
    } = {},
  ) {}

  build(_input: { readonly trpc: unknown }): PlatformGlobals {
    return {
      pdfDownload: new InMemoryPdfDownloadService(),
      origin: this.opts.origin ?? "https://app.panelgenie.com",
    };
  }
}
